import axios from 'axios';
import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import $ from 'jquery';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'datatables.net';
import 'datatables.net-buttons';
import 'datatables.net-buttons-dt/css/buttons.dataTables.css';
import 'datatables.net-buttons/js/buttons.colVis';
import 'datatables.net-buttons/js/buttons.html5';
import 'datatables.net-buttons/js/buttons.print';
import React, { useEffect, useState, useRef, useCallback } from 'react';
import { Link, useLocation, useNavigate, useSearchParams  } from 'react-router-dom';
import { baseurl } from '../utility/helper';
import * as XLSX from 'xlsx';
import ViewCertificate from './ViewCertificate';
import Swal from 'sweetalert2';
import { generateCertificate } from './generateCertificate';
import { downloadHallTicket } from './hallTicket';


const EditTest = () => {
  const roleid = parseInt(sessionStorage.getItem("userroleId"));
  const initialChapter = roleid === 2 ? sessionStorage.getItem("userchapterId") || "" : "";
  const tableRef = useRef(null);
  // When true, the next run of the table-build effect is skipped so an
  // attendance tick updates the grid in place instead of tearing the whole
  // DataTable down (which scrolls the page to the top).
  const skipRebuildRef = useRef(false);
  const location = useLocation();
  const navigate = useNavigate();

  const [selectedCandidates, setSelectedCandidates]   = useState([]);
  // ── NEW ──────────────────────────────────────────────────────────────────
  const [selectedReminders,  setSelectedReminders]    = useState([]);
  const [searchParams] = useSearchParams();
  const testId = searchParams.get('testId');
  const ChapterID = searchParams.get('ChapterID');
  const {edit} = location.state || {};
  const [candidates,  setCandidates]  = useState([]);
  const [isEditing,   setIsEditing]   = useState(edit);
  const [chapters,    setChapters]    = useState([]);
  const [modalType,   setModalType]   = useState('');
  const [error,       setError]       = useState('');
  const [uploadProgress, setUploadProgress] = useState(0);
  const [file,        setFile]        = useState(null);
  const [formData,    setFormData]    = useState({
    chapter_id: '', chapter: '', test_title: '', test_desc: '',
    venue: '', test_start_time: '', test_end_time: '',
    register_start_date: '', register_end_date: '',
    age_group: '', seat: '', note: '', proctor_name: ''
  });
  const [TestName,          setTestName]          = useState(null);
  const [show,              setShow]              = useState(false);
  const [showModal,         setShowModal]         = useState(false);
  const [modalUserCert,     setModalUserCert]     = useState([]);
  const [currentCertIndex,  setCurrentCertIndex]  = useState(0);
  const [proctorName,       setProctorName]       = useState('');
  const [generatingCertId,  setGeneratingCertId]  = useState(null);

  const fetchCandidates = useCallback(async () => {
    try {
      const response = await axios.get(`${baseurl}/admin/testcandidates?testId=${testId}`);
      setCandidates(response.data);
    } catch (error) {
      console.error('Error fetching candidate data:', error);
    }
  }, [testId]);

  const updateCandidateWithFiles = (candidateId, uploadedFiles) => {
    setCandidates(prev =>
      prev.map(c => c.test_candidate_id === candidateId ? { ...c, files: uploadedFiles } : c)
    );
  };

  useEffect(() => {
    dayjs.extend(utc);
    dayjs.extend(timezone);

    const fetchChapters = () => {
      axios.get(`${baseurl}/admin/chapters`)
        .then(r => setChapters(r.data))
        .catch(e => console.error('Error fetching chapters:', e));
    };

    if (testId) {
      axios.get(`${baseurl}/admin/tests/${testId}`)
        .then(response => {
          const data = response.data;
          const formattedData = {
            ...data,
            privilege: data.under_priviledge ? parseInt(data.under_priviledge) : 0,
            isVisible: data.test_status === 'active' ? 1 : 0,
            test_start_time:      dayjs(data.test_start_time).format('YYYY-MM-DDTHH:mm'),
            test_end_time:        dayjs(data.test_end_time).format('YYYY-MM-DDTHH:mm'),
            register_start_date:  dayjs(data.register_start_date).format('YYYY-MM-DDTHH:mm'),
            register_end_date:    dayjs(data.register_end_date).format('YYYY-MM-DDTHH:mm'),
          };
          setFormData(formattedData);
          setTestName(formattedData.test_title);
          // NEW: seed the proctor-name input from whatever was already saved
          setProctorName(formattedData.proctor_name || '');
        })
        .catch(e => console.error('Error fetching test data:', e));

      fetchCandidates();
    }

    fetchChapters();
  }, [testId, fetchCandidates]);

  useEffect(() => {
    const tableElement = tableRef.current;
    if (!tableElement) return;

    // An attendance tick updates the grid in place (see the .attendance-checkbox
    // handler) and asks this effect to skip one rebuild — rebuilding tears down
    // and recreates the whole DataTable DOM, which jumps the page to the top.
    if (skipRebuildRef.current) {
      skipRebuildRef.current = false;
      return;
    }

    if ($.fn.DataTable.isDataTable(tableElement)) {
      $(tableElement).DataTable().destroy();
    }
    $(tableElement).empty();

    const testNameValue = TestName;

    $(tableElement).DataTable({
      dom: 'Blfrtip',
      pageLength: 25,
      lengthMenu: [[10, 25, 50, 100, 250, 500, -1], [10, 25, 50, 100, 250, 500, "All"]],
      buttons: [
        { extend: 'copyHtml5',  className: 'btn btn-primary dttable', exportOptions: { columns: ':visible:not(.notexport)' } },
        {
          extend: 'excelHtml5',
          className: 'btn btn-primary dttable',
          filename: () => 'Mensa_Test_' + (testNameValue || 'Default'),
          title: null,
          exportOptions: {
            columns: ':visible:not(.notexport)',
            rows: function (idx, data, node) {
              return data.attendance === true; // Only Present
            },
            format: {
              body: function (data, row, column, node) {
                if ([20, 21, 22, 23, 24].includes(column)) return ''; // ← 24 added
                if (column === 4) {
                  const checkbox = $(node).find('input[type="checkbox"]');
                  if (checkbox.length) return checkbox.is(':checked') ? 'Present' : 'Absent';
                  const text = $(node).text().trim();
                  if (text.includes('Present')) return 'Present';
                  if (text.includes('Absent'))  return 'Absent';
                  return '';
                }
                return $('<div>').html(data).text();
              }
            }
          },
          customize: function (xlsx) {
            const sheet = xlsx.xl.worksheets['sheet1.xml'];
            const $sheet = $(sheet);
            const attendeeCount = candidates.filter(c => c.attendance === true).length;
            const testDate = formData.test_start_time
              ? dayjs(formData.test_start_time).format('DD MMM YYYY, hh:mm A') : '—';
            const venue = formData.venue || '—';
            const proctorName = formData.proctor_name || '-';
            const summaryRow = `
            <row r="1">
              <c r="A1" t="inlineStr"><is><t>Date of Test: ${testDate}</t></is></c>
              <c r="D1" t="inlineStr"><is><t>Location: ${venue}</t></is></c>
              <c r="G1" t="inlineStr"><is><t>Name of Proctor: — ${proctorName}</t></is></c>
              <c r="J1" t="inlineStr"><is><t>No. of Attendees: ${attendeeCount} / ${candidates.length}</t></is></c>
            </row>`;

            $sheet.find('row').each(function () {
              const r = parseInt($(this).attr('r'));
              $(this).attr('r', r + 1);
              $(this).find('c').each(function () {
                const ref = $(this).attr('r');
                if (ref) $(this).attr('r', ref.replace(/\d+$/, m => String(parseInt(m) + 1)));
              });
            });
            $sheet.find('sheetData').prepend(summaryRow);

            const mergeCells = `
            <mergeCells count="4">
              <mergeCell ref="A1:C1"/>
              <mergeCell ref="D1:F1"/>
              <mergeCell ref="G1:I1"/>
              <mergeCell ref="J1:L1"/>
            </mergeCells>`;
            $sheet.find('mergeCells').remove();
            $sheet.find('sheetData').after(mergeCells);
          }
        },
        { extend: 'csvHtml5', className: 'btn btn-primary dttable', exportOptions: { columns: ':visible:not(.notexport)' } },
        { extend: 'pdfHtml5', className: 'btn btn-primary dttable', exportOptions: { columns: ':visible:not(.notexport)' } },
        { extend: 'print',    className: 'btn btn-primary dttable', exportOptions: { columns: ':visible:not(.notexport)' } },
      ],
      data: candidates,
      order: [[0, 'asc']],
      initComplete: function () {
        $('.dt-length select').addClass('form-select form-select-sm');
        const attendeeCount = candidates.filter(c => c.attendance === true).length;
        const testDate = formData.test_start_time
          ? dayjs(formData.test_start_time).format('DD MMM YYYY, hh:mm A') : '—';
        const venue        = formData.venue        || '—';
        const proctor_name = formData.proctor_name || '—';
        const thead = $(tableRef.current).find('thead');
        if (thead.find('.summary-row').length) return;
        const colCount = thead.find('tr:first th').length;
        const summaryRow = `
          <tr class="summary-row" style="background:#f0f4ff;border-top:2px solid #dee2e6;">
            <th colspan="${colCount}" style="padding:10px 14px;font-size:13px;font-weight:normal;border-bottom:2px solid #adb5bd;white-space:nowrap;">
              <span style="margin-right:48px;"><strong>Date of Test:</strong> ${testDate}</span>
              <span style="margin-right:48px;"><strong>Location:</strong> ${venue}</span>
              <span style="margin-right:48px;"><strong>Name of Proctor:</strong> — ${proctor_name}</span>
              <span><strong>No. of Attendees:</strong> <span class="attendee-count">${attendeeCount} / ${candidates.length}</span></span>
            </th>
          </tr>`;
        thead.prepend(summaryRow);
      },
      columns: [
        // 0 – Sr. No
        { data: null, title: 'Sr. No', render: (data, type, row, meta) => meta.row + 1 },
        // 1 – ID
        {
            data: 'test_candidate_id',
            title: 'ID',
            render: (data, type, row) => {
                const candidateId = row.test_candidate_id;

                if (type !== "display") {
                    return candidateId || "";
                }

                if (!candidateId) {
                    return `<span class="cl-muted">—</span>`;
                }

                const url = `/admin/CandiAdd/${candidateId}`;

                return `
                    <a
                        href="${url}"
                        class="cl-id-link"
                        onclick="event.preventDefault(); window.open(this.href, '_blank');"
                    >
                        ${candidateId}
                    </a>
                `;
            }
        },
        // 2 – Register Date
        {
          data: 'datetime',
          title: 'Register Date',
          render: function (data, type, row) {
            if (!data) return '';

            const d = new Date(data);

            // SORTING (IMPORTANT)
            if (type === 'sort') {
              return d.getTime(); //  numeric sort
            }

            // DISPLAY
            return d.toLocaleString('en-IN', {
              timeZone: 'Asia/Kolkata',
              day: '2-digit',
              month: '2-digit',
              year: 'numeric',
              hour: '2-digit',
              minute: '2-digit',
              hour12: true
            }).replace(',', '');
          }
        },
        // 3-11 – Personal details
       {
          data: null,
          title: 'Name',
          render: function (data, type, row) {
            return `${row.first_name || ''} ${row.last_name || ''}`;
          }
        },
        {
          title: 'Attendance', data: 'attendance',
          render: function (data, type, row) {
            const isAllowed = (String(initialChapter) === String(ChapterID)) || roleid === 1 || roleid === 4;
            const checked = data === true ? 'checked' : '';
            if (isAllowed) {
              return `<center><input type="checkbox" class="attendance-checkbox" data-id="${row.test_candidate_id}" ${checked}/></center>`;
            }
            if (data === true)  return `<span class="badge bg-success">Present</span>`;
            if (data === false) return `<span class="badge bg-danger">Absent</span>`;
            return '';
          }
        },
        // 3 – Photo
        {
          data: 'profile_image',   // ← adjust to your actual field name
          title: 'Photo',
          orderable: false,
          className: 'notexport',  // excluded from all exports
          render: function (data, type, row) {
            if (!data) {
              return `<div style="width:40px;height:40px;border-radius:50%;background:var(--bs-secondary-bg,#e9ecef);display:flex;align-items:center;justify-content:center;font-size:18px;margin:auto;">👤</div>`;
            }
            return `<img src="${data}" alt="Photo"
              style="width:40px;height:40px;border-radius:50%;object-fit:cover;display:block;margin:auto;border:1px solid #dee2e6;"
              onerror="this.style.display='none'"
            />`;
          }
        },
        { data: 'mobile_no',   title: 'Mobile No', className: 'text-left' },
        { data: 'email',       title: 'Email' },
        { data: 'address',        title: 'Address' },
        { data: 'gender',      title: 'Gender' },
        {
          data: 'dob', title: 'DOB',
          render: function (data) {
            if (!data) return '';
            const d = new Date(data);
            return `${String(d.getDate()).padStart(2,'0')}-${String(d.getMonth()+1).padStart(2,'0')}-${d.getFullYear()}`;
          }
        },
        
        { data: 'state',          title: 'State' },
        { data: 'city',           title: 'City' },
        { data: 'last_education', title: 'Last Education' },

        // 12 – Attendance


        // 13-18 – Score columns
        { data: 'met1_pr',      title: 'MET1',       render: data => data ?? '' },
        { data: 'met1_gr',      title: 'MET1- GR',       render: data => data ?? '' },
        { data: 'met2_pr',      title: 'MET2',       render: data => data ?? '' },
        { data: 'met2_gr',      title: 'MET2- GR',       render: data => data ?? '' },
        { 
          data: 'marks_obtain', 
          title: 'Marks Obtained', 
          render: data => {
            if (data == null) return '';
            return data < 25 ? 'Below 25' : data;
          }
        },
        { data: 'result_status',title: 'Result',         render: data => data ?? '' },
        {
          title: 'Hall Ticket',
          data: null,
          orderable: false,
          className: 'notexport', // ❌ exclude from export
          render: function (data, type, row) {
            return `<button class="btn btn-info btn-sm hall-ticket-btn" data-id="${row.test_candidate_id}">
                      🎫 Hall Ticket
                    </button>`;
          }
        },
        // 19 – Generate Certificate
        {
          title: 'Generate Cert.', data: null, orderable: false,
          render: function (data, type, row) {
            const hasResult = row.result_status !== null && row.result_status !== undefined && row.result_status !== '';
            if (!hasResult) {
              return '<div style="text-align:center;color:gray;padding:4px 8px;border:1px solid #ccc;border-radius:4px;background:#f0f0f0;cursor:not-allowed;font-size:12px">No Result</div>';
            }
            const isPass = String(row.result_status).toLowerCase() === 'pass';
            return isPass
              ? `<button class="btn btn-success btn-sm gen-cert-btn" data-id="${row.test_candidate_id}" title="Download Pass Letter">✅ Pass Letter</button>`
              : `<button class="btn btn-warning btn-sm gen-cert-btn" data-id="${row.test_candidate_id}" title="Download Fail Letter" style="color:#333">📄 Fail Letter</button>`;
          }
        },

        // 20 – Upload Certificate
        {
          title: 'Upload Cert.',
          render: function (data, type, row) {
            const allowed = (String(initialChapter) === String(ChapterID)) || roleid === 1 || roleid === 4;
            if (allowed) {
              return row.result_status != null
                ? `<button class='btn btn-primary btn-sm upload-btn' data-id='${row.test_candidate_id}'>Upload</button>`
                : '<div style="text-align:center;color:gray;padding:4px 8px;border:1px solid #ccc;border-radius:4px;background:#f0f0f0;cursor:not-allowed;font-size:12px">Disabled</div>';
            }
            return '<div style="text-align:center;color:gray;padding:4px 8px;border:1px solid #ccc;border-radius:4px;background:#f0f0f0;cursor:not-allowed;font-size:12px">Disabled</div>';
          }
        },

        // 21 – View Certificate
        {
          title: 'View Cert.',
          render: function (data, type, row) {
            return (row.certificate != null)
              ? `<button class="btn btn-success btn-sm view-btn" data-id="${row.test_candidate_id}">View</button>`
              : '<div style="text-align:center;color:gray;padding:4px 8px;border:1px solid #ccc;border-radius:4px;background:#f0f0f0;cursor:not-allowed;font-size:12px">Disabled</div>';
          }
        },

        // 22 – Send Email (existing)
        {
          title: `<input type='checkbox' id='select-all' class='styled-checkbox'> Send Email`,
          data: null, orderable: false,
          render: function (data, type, row) {
            if ((String(initialChapter) === String(ChapterID)) || roleid === 1 || roleid === 4) {
              const isAbsent = row.attendance === false || row.attendance === null || row.attendance === undefined; //
              const disabled = isAbsent ? 'disabled' : '';
              const disabledStyle = isAbsent ? 'opacity:0.4; cursor:not-allowed;' : '';
              return `<center><input type='checkbox' class='row-checkbox styled-checkbox' data-id='${row.test_candidate_id}' ${disabled} style='${disabledStyle}'/></center>`;
            }
            return '';
          }
        },

        // ── NEW Col 23 – Send Reminder ─────────────────────────────────────
        {
          title: `<input type='checkbox' id='select-all-reminder' class='styled-checkbox'> Send Reminder`,
          data: null, orderable: false,
          render: function (data, type, row) {
            if ((String(initialChapter) === String(ChapterID)) || roleid === 1 || roleid === 4) {
              return `<center><input type='checkbox' class='reminder-checkbox styled-checkbox' data-id='${row.test_candidate_id}'/></center>`;
            }
            return '';
          }
        },
      ],
    });

    // ── Event: Select All (Send Email) ───────────────────────────────────────
    $('#select-all').on('click', function () {
      $('.row-checkbox:not(:disabled)').prop('checked', $(this).prop('checked')); // skip disabled
      updateSelectedCandidates();
    });
    $(tableElement).off('click', '.hall-ticket-btn').on('click', '.hall-ticket-btn', function () {
      const candidateId = $(this).data('id');
      const candidate = candidates.find(c => c.test_candidate_id === candidateId);

      if (!candidate) return;

      // Pass candidate + test data
      downloadHallTicket(formData, candidate);
    });
    // ── NEW Event: Select All (Send Reminder) ────────────────────────────────
    $('#select-all-reminder').on('click', function () {
      $('.reminder-checkbox').prop('checked', $(this).prop('checked'));
      updateSelectedReminders();
    });

    // ── Event: Attendance ────────────────────────────────────────────────────
    $(tableElement).off('change', '.attendance-checkbox').on('change', '.attendance-checkbox', async function () {
      const candidateId = $(this).data('id');
      const isPresent   = $(this).is(':checked');
      const token       = sessionStorage.getItem("token");
      try {
        await axios.patch(
          `${baseurl}/admin/testcandidates/attendance?testId=${testId}&candidateId=${candidateId}`,
          { attendance: isPresent },
          { headers: { Authorization: token, 'Content-Type': 'application/json' } }
        );

        // Update the grid in place — no full DataTable rebuild (which would
        // scroll the page to the top).
        const dt = $(tableElement).DataTable();
        const rowIdx = dt.rows().indexes().toArray()
          .find(i => dt.row(i).data() && dt.row(i).data().test_candidate_id === candidateId);
        if (rowIdx !== undefined) {
          const d = dt.row(rowIdx).data();
          d.attendance = isPresent;
          dt.row(rowIdx).data(d);   // re-renders just this row (checkbox + email/reminder cells)
        }
        dt.draw(false);             // keep current page & scroll position

        // Refresh the "No. of Attendees" summary figure.
        const rows = dt.rows().data().toArray();
        const attendeeCount = rows.filter(c => c.attendance === true).length;
        $(tableElement).find('.attendee-count').text(`${attendeeCount} / ${rows.length}`);

        // Keep React state in sync for exports / certificates, but skip the
        // rebuild this setCandidates would otherwise trigger.
        skipRebuildRef.current = true;
        setCandidates(prev =>
          prev.map(c => c.test_candidate_id === candidateId ? { ...c, attendance: isPresent } : c)
        );
      } catch (err) {
        console.error('Failed to update attendance:', err);
        $(this).prop('checked', !isPresent);
      }
    });

    // ── Event: Generate Certificate ──────────────────────────────────────────
    $(tableElement).off('click', '.gen-cert-btn').on('click', '.gen-cert-btn', async function () {
      const candidateId = $(this).data('id');
      const candidate   = candidates.find(c => c.test_candidate_id === candidateId);
      if (!candidate) return;

      const $btn = $(this);
      $btn.prop('disabled', true).text('Generating…');

      try {
        const testDate = formData.test_start_time
          ? dayjs(formData.test_start_time).format('D MMMM YYYY') : '—';
        await generateCertificate({
          candidate,
          testDate,
          testLocation: formData.venue || '—',
          format: 'pdf',
        });
      } catch (err) {
        console.error('Certificate error:', err);
        Swal.fire({ icon: 'error', title: 'Error', text: 'Could not generate certificate. Please try again.' });
      } finally {
        const isPass = String(candidate.result_status).toLowerCase() === 'pass';
        $btn.prop('disabled', false).text(isPass ? '✅ Pass Letter' : '📄 Fail Letter');
      }
    });

    // ── Event: Upload Certificate ────────────────────────────────────────────
    $(tableElement).off('click', '.upload-btn').on('click', '.upload-btn', function () {
      const candidateId = $(this).data('id');
      const input = $('<input>').attr({ type: 'file', multiple: true });
      input.on('change', function () {
        const files = this.files;
        if (!files.length) return;
        const fd = new FormData();
        for (let i = 0; i < files.length; i++) fd.append('files', files[i]);
        const url = `${baseurl}/admin/testcandidates/certificate/upload?testId=${testId}&candidateId=${candidateId}`;
        axios.post(url, fd, { headers: { 'Content-Type': 'multipart/form-data' } })
          .then(async () => {
            await fetchCandidates();   // ← full refresh from server
            alert('Upload successful');
          })
          .catch(() => alert('Upload failed'));
      });
      input.trigger('click');
    });

    // ── Event: Row checkbox (Send Email) ─────────────────────────────────────
    $(tableElement).off('click', '.row-checkbox').on('click', '.row-checkbox', updateSelectedCandidates);

    // ── NEW Event: Row checkbox (Send Reminder) ──────────────────────────────
    $(tableElement).off('click', '.reminder-checkbox').on('click', '.reminder-checkbox', updateSelectedReminders);

  // NEW: added formData.proctor_name so the table (and its summary row)
  // rebuilds when the proctor name is saved, not just when candidates change.
  }, [candidates, formData.proctor_name]);


  // ── View Certificate ──────────────────────────────────────────────────────
  $(document).off('click', '.view-btn').on('click', '.view-btn', async function () {
    const userId    = $(this).data('id');
    const candidate = candidates.find(x => x.test_candidate_id === userId);
    let certArray   = [];
    if (candidate?.files?.length > 0) {
      certArray = candidate.files;
      setModalUserCert(certArray); setShowModal(true); setCurrentCertIndex(0);
    } else {
      try {
        const url      = `${baseurl}/admin/testcandidates/certificate/download?testId=${testId}&candidateId=${userId}`;
        const response = await axios.get(url);
        if (response.data?.url?.length > 0) {
          certArray = response.data.url;
          if (candidate) candidate.files = certArray;
          setModalUserCert(certArray); setShowModal(true); setCurrentCertIndex(0);
        } else { alert('No certificates found.'); }
      } catch { alert('Failed to load certificates.'); }
    }
  });

  // ── Helpers: track selected IDs ──────────────────────────────────────────
  const updateSelectedCandidates = () => {
    const selected = [];
    $('.row-checkbox:checked').each(function () { selected.push($(this).data('id')); });
    setSelectedCandidates(selected);
  };

  // ── NEW: track selected reminder IDs ─────────────────────────────────────
  const updateSelectedReminders = () => {
    const selected = [];
    $('.reminder-checkbox:checked').each(function () { selected.push($(this).data('id')); });
    setSelectedReminders(selected);
  };

  // ── Send Result Email ─────────────────────────────────────────────────────
  const handleSendMail = async () => {
    if (!selectedCandidates.length) { alert("Please select at least one candidate."); return; }
    try {
      await axios.post(
        `${baseurl}/admin/testcandidates/result/send_email?testId=${testId}`,
        { ids: selectedCandidates }
      );
      alert("Emails sent successfully!");
    } catch { alert("Error sending emails. Check console."); }
  };

  // ── NEW: Send Reminder Email ──────────────────────────────────────────────
  const handleSendReminder = async () => {
    if (!selectedReminders.length) { alert("Please select at least one candidate."); return; }
    const result = await Swal.fire({
      title:  'Send Reminder?',
      text:   `Send a reminder email to ${selectedReminders.length} selected candidate(s)?`,
      icon:   'question',
      showCancelButton:    true,
      confirmButtonColor:  '#f59e0b',
      cancelButtonColor:   '#6b7280',
      confirmButtonText:   'Yes, Send Reminder',
    });
    if (!result.isConfirmed) return;

    try {
      await axios.post(
        `${baseurl}/admin/testcandidates/reminder/send_email?testId=${testId}`,
        { ids: selectedReminders },
        { headers: { Authorization: sessionStorage.getItem("token"), 'Content-Type': 'application/json' } }
      );
      Swal.fire({ icon: 'success', title: 'Sent!', text: 'Reminder emails sent successfully.', timer: 2000, showConfirmButton: false });
      // Uncheck all reminder boxes after sending
      $('.reminder-checkbox, #select-all-reminder').prop('checked', false);
      setSelectedReminders([]);
    } catch (err) {
      Swal.fire({ icon: 'error', title: 'Error', text: err.response?.data?.message || 'Failed to send reminder emails.' });
    }
  };

  const handleShow       = (type) => { setModalType(type); setShow(true); };
  const handleEditMode   = () => setIsEditing(true);
  const handleClose      = () => setIsEditing(false);
  const handleChange     = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleShare = () => {
    if (!testId) {
      Swal.fire("Error", "Test ID not found", "error");
      return;
    }

    const link = `https://mensaindia.org/ViewTest?testId=${testId}`;

    navigator.clipboard.writeText(link)
      .then(() => {
        Swal.fire({
          icon: 'success',
          title: 'Link Copied!',
          text: link,
          confirmButtonColor: '#3085d6',
        });
      })
      .catch(() => {
        Swal.fire("Error", "Failed to copy link", "error");
      });
  };

  const handleDeleteMode = (testId) => {
    const token = sessionStorage.getItem("token");
    Swal.fire({
      title: "Are you sure?", text: "You won't be able to revert this!", icon: "warning",
      showCancelButton: true, confirmButtonColor: "#3085d6", cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        fetch(`${baseurl}/admin/tests/${testId}`, {
          method: "DELETE",
          headers: { Authorization: `${token}`, "Content-Type": "application/json" },
        })
          .then(res => res.json())
          .then(response => {
            Swal.fire("Deleted!", response.message, "success")
              .then(() => navigate("/admin/TestList"));
          })
          .catch(err => Swal.fire("Error!", err?.message || "Error deleting test.", "error"));
      }
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const submitData = {
      ...formData,
      privilege:  formData.privilege  ? 1 : 0,
      isVisible:  formData.isVisible === 1 ? 'active' : 'not-active',
    };
    axios.put(`${baseurl}/admin/tests/${testId}`, submitData)
      .then(() => setIsEditing(false))
      .catch(e => console.error('Error saving data:', e));
  };

  // ── Upload Result ─────────────────────────────────────────────────────────
  const handelResultSubmit = async () => {
    if (!file) { console.log('No file selected'); return; }
    const reader = new FileReader();
    reader.onload = async (e) => {
      const data     = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: 'array' });
      const worksheet = workbook.Sheets[workbook.SheetNames[0]];
      const rows      = XLSX.utils.sheet_to_json(worksheet, { header: 1, defval: null });
      const dataRows  = rows.slice(2).filter(row => row[1] !== null && row[1] !== undefined);
      const normalizedCandidates = dataRows.map(row => {
        const met1_pr = row[13] ? String(row[13]).trim() : null;
        const met2_pr = row[15] ? String(row[15]).trim() : null;

        // For calculation ONLY
        const getNumber = (val) => {
          if (!val) return 0;
          return Number(String(val).replace('+', '')) || 0;
        };

        const num1 = getNumber(met1_pr);
        const num2 = getNumber(met2_pr);
        const maxMarks = Math.max(num1, num2);

        // New logic for marks_obtain
        let marks_obtain = null;

        if (met1_pr === '99+' || met2_pr === '99+') {
          marks_obtain = '99+';
        } else if (met1_pr !== null || met2_pr !== null) {
          marks_obtain = `${maxMarks}`;
        }
        return {
          test_candidate_id: row[1],
          attendance: row[12] === 'Present' ? true : row[12] === 'Absent' ? false : null,
          met1_pr,
          met1_gr:     row[14] ?? null,
          met2_pr,
          met2_gr:     row[16] ?? null,
          marks_obtain,
          result: row[18]
          ? row[18].charAt(0).toUpperCase() + row[18].slice(1).toLowerCase()
          : null,
        };
      });
      try {
        const response = await axios.post(
          `${baseurl}/admin/testcandidates/result?testId=${testId}`,
          { candidates: normalizedCandidates }
        );
        await fetchCandidates(); 
        alert('Upload Result successfully');
        setFile(null); 
        setUploadProgress(0); 
        setError('');
        // setCandidates(response.data);
        handleModalClose();
      } catch (error) {
        console.error('❌ Failed to submit results:', error);
      }
    };
    reader.readAsArrayBuffer(file);
  };

  const handleFileUpload    = (e) => { const f = e.target.files[0]; if (validateFile(f)) { setFile(f); simulateUploadProgress(); } };
  const handleDrop          = (e) => { e.preventDefault(); const f = e.dataTransfer.files[0]; if (validateFile(f)) { setFile(f); simulateUploadProgress(); } };
  const validateFile        = (f) => {
    const valid = ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.ms-excel'];
    if (f && valid.includes(f.type)) { setError(''); return true; }
    setError('Please upload a valid Excel file (.xls, .xlsx).');
    return false;
  };
  const handleDragOver      = (e) => e.preventDefault();
  const simulateUploadProgress = () => {
    const interval = setInterval(() => {
      setUploadProgress(prev => { if (prev >= 100) { clearInterval(interval); return 100; } return prev + 10; });
    }, 300);
  };
  const handleModalClose    = () => { setFile(null); setUploadProgress(0); setError(''); setShow(false); };

  const handleDownload = async (url, fileName = "certificate.jpg") => {
    try {
      const response = await fetch(url);
      if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
      const blob    = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);
      const link    = document.createElement("a");
      link.href = blobUrl; link.download = fileName;
      document.body.appendChild(link); link.click();
      window.URL.revokeObjectURL(blobUrl); link.remove();
    } catch (err) { alert("Failed to download certificate. Please try again."); }
  };

  const handleProctorSave = async () => {
    try {
      await axios.patch(
        `${baseurl}/admin/tests/${testId}/proctor`,
        { proctor_name: proctorName },
        { headers: { Authorization: sessionStorage.getItem("token"), 'Content-Type': 'application/json' } }
      );
      // NEW: push the saved name into formData so the summary row (which
      // reads formData.proctor_name) picks it up on the next table rebuild.
      setFormData(prev => ({ ...prev, proctor_name: proctorName }));
      Swal.fire({ icon: 'success', title: 'Saved!', text: 'Proctor name saved.', timer: 1500, showConfirmButton: false });
    } catch {
      Swal.fire({ icon: 'error', title: 'Error', text: 'Failed to save proctor name.' });
    }
  };

  return (
    <div className="">
      <div className="container mt-4">
        <button className="cl-back-btn "  onClick={() => navigate("/admin/TestList")}>
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"><path d="M10 3L5 8l5 5"/></svg>
            Back
        </button>
        <div className="col-md-12 text-end">
          <ViewCertificate isOpen={showModal} onClose={() => setShowModal(false)}>
            <div style={{ display:'flex', justifyContent:'center', alignItems:'center', height:'90vh', width:'100%' }}>
              <div style={{ width:'80%', height:'90%', backgroundColor:'#fff', borderRadius:'10px', padding:'20px', boxShadow:'0 0 10px rgba(0,0,0,0.2)', overflow:'auto', display:'flex', flexDirection:'column', alignItems:'center' }}>
                <h2 style={{ textAlign:'center' }}>Uploaded Certificates</h2>

                {modalUserCert.length > 0 ? (() => {
                  const currentFile = modalUserCert[currentCertIndex];
                  if (!currentFile) return <p>No file available</p>;
                  const fileName = currentFile.filename || '';
                  const isPDF    = fileName.toLowerCase().includes('.pdf');
                  return (
                    <div style={{ textAlign:'center', flexGrow:1 }}>
                      <div style={{ position:'relative', display:'inline-block', maxWidth:'80vw' }}>
                        {isPDF ? (
                          <iframe
                            src={`https://drive.google.com/viewerng/viewer?embedded=true&url=${encodeURIComponent(currentFile.presignedUrl)}`}
                            title="PDF Viewer"
                            style={{ width:'100%', height:'60vh', border:'1px solid #ccc', borderRadius:'8px' }}
                          />
                        ) : (
                          <img
                            src={currentFile.presignedUrl}
                            alt="Certificate"
                            style={{ maxWidth:'100%', maxHeight:'60vh', borderRadius:'8px', border:'1px solid #ccc' }}
                            onError={(e) => { e.target.style.display = 'none'; }}
                          />
                        )}
                        {modalUserCert.length > 1 && (
                          <>
                            <button onClick={() => setCurrentCertIndex(p => p === 0 ? modalUserCert.length - 1 : p - 1)}
                              style={{ position:'absolute', left:'-40px', top:'50%', transform:'translateY(-50%)' }}>&#8592;</button>
                            <button onClick={() => setCurrentCertIndex(p => (p + 1) % modalUserCert.length)}
                              style={{ position:'absolute', right:'-40px', top:'50%', transform:'translateY(-50%)' }}>&#8594;</button>
                          </>
                        )}
                        <p style={{ marginTop:'10px' }}>{fileName}</p>
                        <a
                          href={modalUserCert[currentCertIndex].presignedUrl}
                          download={modalUserCert[currentCertIndex].filename}
                          target="_blank" rel="noopener noreferrer"
                          style={{ padding:'10px 20px', backgroundColor:'#4CAF50', color:'white', borderRadius:'5px', fontWeight:'bold', cursor:'pointer', textDecoration:'none', display:'inline-block' }}
                        >
                          ⬇️ Download Certificate
                        </a>
                      </div>
                    </div>
                  );
                })() : <p>No certificates available</p>}
              </div>
            </div>
          </ViewCertificate>
          <button className="btn btn-success" onClick={handleShare}>
            Share
          </button>&nbsp;
          {(roleid === 1 || String(initialChapter) === String(formData.chapter_id)) && (
            <>{!isEditing && <button className="btn btn-primary" onClick={handleEditMode}>Edit</button>}&nbsp;</>
          )}
          {roleid === 1 && (
            <><button className="btn btn-danger" onClick={() => handleDeleteMode(testId)}>Delete</button>&nbsp;</>
          )}
          {(roleid === 1 || roleid === 4 || String(initialChapter) === String(formData.chapter_id)) && (
            <><button className="btn btn-primary" onClick={() => handleShow('result')}><i className="bx bxs-plus-circle mr-2"></i> Upload Result</button>&nbsp;</>
          )}
        </div>

        <form onSubmit={handleSubmit}>
          <div className="profile-section" style={{ marginTop:'20px' }}>
            <center><h3><b>View Test</b></h3></center>
            <div className="col-md-12">
              <div className="row">
                <div className="col-md-6">
                  <label>Select Chapter:</label>
                  <select className="form-select" id="chapter_id" name="chapter_id" value={formData.chapter_id} onChange={handleChange} disabled={!isEditing}>
                    <option value="">Select a Chapter</option>
                    {chapters.map(c => <option key={c.chapter_id} value={c.chapter_id}>{c.chapter_name}</option>)}
                  </select>
                </div>
                <div className="col-md-6">
                  <label>Test Title:</label>
                  <input type="text" name="test_title" className="form-control" value={formData.test_title} onChange={handleChange} disabled={!isEditing} />
                </div>
                <div className="col-md-6" style={{ paddingTop:'20px' }}>
                  <label>Test Description:</label>
                  <textarea name="test_desc" className="form-control" value={formData.test_desc} onChange={handleChange} disabled={!isEditing} />
                </div>
                <div className="col-md-6" style={{ paddingTop:'20px' }}>
                  <label>Test Venue:</label>
                  <input type="text" name="venue" className="form-control" value={formData.venue} onChange={handleChange} disabled={!isEditing} />
                </div>
                <div className="col-md-6" style={{ paddingTop:'20px' }}>
                  <label>Registration Start Date:</label>
                  <input type="datetime-local" className="form-control" name="register_start_date" value={formData.register_start_date} onChange={handleChange} disabled={!isEditing} />
                </div>
                <div className="col-md-6" style={{ paddingTop:'20px' }}>
                  <label>Registration End Date:</label>
                  <input type="datetime-local" className="form-control" name="register_end_date" value={formData.register_end_date} onChange={handleChange} min={formData.register_start_date} disabled={!isEditing} />
                </div>
                <div className="col-md-6" style={{ paddingTop:'20px' }}>
                  <label>Test Start Time:</label>
                  <input type="datetime-local" className="form-control" name="test_start_time" value={formData.test_start_time} onChange={handleChange} min={formData.register_end_date} disabled={!isEditing} />
                </div>
                <div className="col-md-6" style={{ paddingTop:'20px' }}>
                  <label>Test End Time:</label>
                  <input type="datetime-local" className="form-control" name="test_end_time" value={formData.test_end_time} min={formData.test_start_time} onChange={handleChange} disabled={!isEditing} />
                </div>
                <div className="col-md-6" style={{ paddingTop:'20px' }}>
                  <label>Age Group:</label>
                  <select name="age_group" value={formData.age_group} onChange={handleChange} disabled={!isEditing} className="form-select">
                    <option value="10-14.5">10 to 14.5 years</option>
                    <option value="14.5-99">14.5 to 99 years</option>
                  </select>
                </div>
                <div className="col-md-6" style={{ paddingTop:'20px' }}>
                  <label>Seat Capacity:</label>
                  <select name="seat" value={formData.seat} className="form-select" disabled={!isEditing} onChange={handleChange}>
                    {[...Array(35)].map((_, i) => <option key={i+1} value={i+1}>{i+1}</option>)}
                  </select>
                </div>
                <div className="col-md-12 mt-2" style={{ paddingTop:'10px' }}>
                  <div className="form-check">
                    <input className="form-check-input" type="checkbox" id="privilege" name="privilege"
                      checked={formData.privilege === 1} disabled={!isEditing}
                      onChange={e => setFormData({ ...formData, privilege: e.target.checked ? 1 : 0 })} />
                    <label className="form-check-label" htmlFor="privilege">Under Privilege</label>
                  </div>
                </div>
                <div className="col-md-12 mt-2" style={{ paddingTop:'10px' }}>
                  <div className="form-check form-switch">
                    <input className="form-check-input" type="checkbox" id="isVisible" name="isVisible"
                      checked={formData.isVisible === 1} disabled={!isEditing}
                      onChange={e => setFormData({ ...formData, isVisible: e.target.checked ? 1 : 0 })} />
                    <label className="form-check-label" htmlFor="isVisible">Visible</label>
                  </div>
                </div>
                <div className="col-md-12" style={{ paddingTop:'10px' }}>
                  <label>Note:</label>
                  <textarea name="note" className="form-control" disabled={!isEditing} value={formData.note} onChange={handleChange} />
                </div>
              </div>
            </div>
          </div>
          {isEditing && (
            <div className="text-center" style={{ marginTop:'20px' }}>
              <button type="button" className="btn btn-secondary" onClick={handleClose}>Cancel</button> &nbsp;
              <button type="submit" className="btn btn-primary">Save</button>
            </div>
          )}
        </form>

        {/* Upload Result Modal */}
        <div className={`modal ${show ? 'show' : ''}`} style={{ display: show ? 'block' : 'none' }}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">{modalType === 'result' ? 'Upload Result' : 'Upload Certificate'}</h5>
                <button type="button" className="btn-close" onClick={handleModalClose}></button>
              </div>
              <div className="modal-body">
                <input type="file" onChange={handleFileUpload} onDrop={handleDrop} onDragOver={handleDragOver} id='modal-file' />
                {error && <p className="text-danger">{error}</p>}
                {file  && <p>Selected file: {file.name}</p>}
                <div className="progress">
                  <div className="progress-bar" role="progressbar" style={{ width:`${uploadProgress}%` }}
                    aria-valuenow={uploadProgress} aria-valuemin="0" aria-valuemax="100">
                    {uploadProgress}%
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={handleModalClose}>Close</button>
                <button type="button" className="btn btn-primary" onClick={handelResultSubmit}>Submit</button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="container mt-4">
        <div className="profile-section">
          <center><h2>Candidates Result</h2></center>

          {/* ── Action buttons above table ───────────────────────────────── */}
          <div className="d-flex align-items-center gap-2 mb-3 flex-wrap">

            {/* Send Mail button (existing) */}
            {selectedCandidates.length > 0 && (
              <button className="btn btn-warning" onClick={handleSendMail}>
                ✉ Send Test Mail to {selectedCandidates.length} Candidate{selectedCandidates.length > 1 ? 's' : ''}
              </button>
            )}

            {/* ── NEW: Send Reminder button ─────────────────────────────── */}
            {selectedReminders.length > 0 && (
              <button className="btn btn-info text-white" onClick={handleSendReminder}>
                🔔 Send Reminder to {selectedReminders.length} Candidate{selectedReminders.length > 1 ? 's' : ''}
              </button>
            )}
          </div>

          <div className="d-flex align-items-center gap-2 mb-3" style={{ maxWidth:'420px' }}>
            <label className="fw-semibold mb-0 text-nowrap">Name of Proctor:</label>
            <input
              type="text"
              className="form-control form-control-sm"
              placeholder="Enter proctor name"
              value={proctorName}
              onChange={e => setProctorName(e.target.value)}
              onKeyDown={e => { if (e.key === 'Enter') handleProctorSave(); }}
            />
            <button className="btn btn-primary btn-sm text-nowrap" onClick={handleProctorSave}>Enter</button>
          </div>

          <div className="table-container" style={{ overflowX:'auto' }}>
            <table ref={tableRef} className="table table-striped table-bordered"></table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditTest;